import { getBaseUrl } from "./getBaseUrl";

interface Config {
  env: "local" | "development" | "production" | "preview";
  site: {
    url: string;
  };
  emails: {
    support: string;
    sales: string;
    security: string;
    legal: string;
    team: string;
  };
  blog?: {
    notionToken: string;
    notionDatabaseId: string;
    notionDataSourceId: string;
  };
  cal: {
    url: string;
  };
  apm: {
    sampling: number;
  };
}

export const config: Config = {
  env: process.env.NODE_ENV as "local" | "development" | "production" | "preview",
  site: {
    url: getBaseUrl(),
  },
  emails: {
    support: "team@lucienai.io",
    sales: "sales@lucienai.io",
    security: "security@lucienai.io",
    legal: "legal@lucienai.io",
    team: "team@lucienai.io",
  },
  blog: {
    notionToken: process.env.NOTION_TOKEN as string,
    notionDatabaseId: process.env.NOTION_BLOG_DATABASE_ID as string,
    notionDataSourceId: process.env.NOTION_BLOG_DATA_SOURCE_ID as string,
  },
  cal: {
    url: "https://cal.com/lucien-ai/founder-chat?user=lucien-ai&duration=30",
  },
  apm: {
    sampling: parseFloat(process.env.NEXT_PUBLIC_APM_SAMPLING || "0.1"),
  },
};
